class FeaturedCardsCarousel extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded')
      return
    }

    const sectionId = this.dataset.sectionId
    const swiperElem = this.querySelector(
      `#featured-cards-carousel-${sectionId}`
    )

    if (!swiperElem) return

    const allowMousewheel = this.dataset.allowMousewheel === 'true'
    const allowAutoplay = this.dataset.allowAutoplay === 'true'
    const playInLoop = this.dataset.playInLoop === 'true'
    const autoplayDelay = parseInt(this.dataset.autoplayDelay || '2500', 10)
    const autoplayDisableOnInteraction =
      this.dataset.autoplayDisableOnInteraction === 'true'
    const hideSectionContent = this.dataset.hideSectionContent === 'true'

    let autoplay = undefined
    if (allowAutoplay) {
      autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: autoplayDisableOnInteraction,
      }
    }

    let breakpoints = {
      0: {
        slidesPerView: 1.5,
      },
      1080: {
        slidesPerView: 1.8,
      },
      1300: {
        slidesPerView: 2.25,
      },
      1500: {
        slidesPerView: 3.2,
      },
    }

    if (hideSectionContent) {
      breakpoints = {
        0: {
          slidesPerView: 1.5,
        },
        600: {
          slidesPerView: 2.25,
        },
        850: {
          slidesPerView: 2.8,
        },
        1200: {
          slidesPerView: 3.25,
        },
        1300: {
          slidesPerView: 4.2,
        },
      }
    }

    this.swiper = new Swiper(swiperElem, {
      mousewheel: allowMousewheel,
      autoplay,
      loop: playInLoop,
      spaceBetween: 8,
      slidesPerView: 3.2,
      breakpoints,
    })
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true)
    }
  }
}

customElements.define('featured-cards-carousel', FeaturedCardsCarousel)
